export enum UserMenuItemEnum {
  // Избранные закупки
  FAVORITE_TRADES_CATEGORY = 'FavoriteTradesCategory',
  // Загрузки
  DOWNLOADS_CATEGORY = 'DownloadsCategory',
  // Закупки
  TRADES_CATEGORY = 'TradesCategory',
  // Протоколы
  PROTOCOLS_CATEGORY = 'ProtocolsCategory',
  // Контракты
  CONTRACTS_CATEGORY = 'ContractsCategory',
  // Торговые сессии
  TRADINGS_CATEGORY = 'TradingsCategory',
  // Запросы
  REGISTER_OF_INQUIRIES_CATEGORY = 'RegisterOfInquiriesCategory',
  // Календарь
  CALENDAR_CATEGORY = 'CalendarCategory',
  // Отчеты
  REPORTS_CATEGORY = 'ReportsCategory',
  // Реестр отчетов
  REPORTS_REGISTRY = 'ReportsRegistry',
  // Графическая аналитика
  GRAPHIC_ANALYTICS = 'GraphicAnalytics',
  // Мастер заказчика
  CUSTOMER_MASTER = 'CustomerMaster',
  // Уведомления
  NOTIFICATIONS_CATEGORY = 'NotificationsCategory',
  // Сервисы
  SERVICES_CATEGORY = 'ServicesCategory',
  // Реестры
  REGISTRIES_CATEGORY = 'RegistriesCategory',
  // Администрирование
  ADMINISTRATION_CATEGORY = 'AdministrationCategory',
  // АРМ САБ
  ARM_SAB_CATEGORY = 'ArmSabCategory',
  // Онлайн-помощник
  ONLINE_ASSISTANT_CATEGORY = 'OnlineAssistantCategory',
  // ЭДО
  EDO = 'Edo',
  // О контрагенте
  ABOUT_COUNTERPARTY = 'AboutCounterparty',
  // Сервисы СТАР для Заказчиков
  CUSTOMER_STAR_SERVICES = 'CustomerStarServices',
  // Проверка ОКПД2/КТРУ
  OKPD2_CHECK = 'Okpd2Check',
  // Запрос КП
  COMMERCIAL_PROPOSALS_REQUEST_SERVICE = 'CommercialProposalsRequestService',
  // Обоснование НМЦК (товары)
  NMCK_JUSTIFICATION_OF_PRODUCTS = 'NmckJustificationOfProducts',
  // Обоснование НМЦК (медицинские изделия)
  NMCK_JUSTIFICATION_OF_MEDICAL_PRODUCTS = 'NmckJustificationOfMedicalProducts',
  // Обоснование НМЦК (лекарственные средства)
  NMCK_JUSTIFICATION_OF_MEDICINES = 'NmckJustificationOfMedicines',
  // Обоснование НМЦК (охранные услуги)
  NMCK_JUSTIFICATION_OF_SECURITY_SERVICES = 'NmckJustificationOfSecurityServices',
  // Калькулятор сроков закупки
  CALCULATOR_OF_PURCHASE_TIME = 'CalculatorOfPurchaseTime',
  // Поиск примеров документации
  DOCUMENTATION_EXAMPLES_SEARCH = 'DocumentationExamplesSearch',
  // Проверка документации
  DOCUMENTATION_CHECK = 'DocumentationCheck',
  // Поиск поставщиков
  SUPPLIERS_SEARCH = 'SuppliersSearch',
  // Проверка контрагента
  COUNTERPARTY_CHECK = 'CounterpartyCheck',
  // Проверка аффилированности
  AFFILIATION_CHECK = 'AffiliationCheck',
  // Мониторинг цен госзакупок
  GOVERNMENT_PROCEDURES_PRICE_MONITORING = 'GovernmentProceduresPriceMonitoring',
  // Квотирование закупок
  PROCUREMENT_QUOTAS = 'ProcurementQuotas',
  // Сервисы Эконом-Эксперт
  ECONOM_EXPERT_SERVICES = 'EconomExpertServices',
  // Реестр участников
  PARTICIPANTS_REGISTER = 'ParticipantsRegister',
  // Реестр заказчиков
  CUSTOMERS_REGISTER = 'CustomersRegister',
  // Реестр закупок
  TRADES_REGISTER = 'TradesRegister',
  // Реестр предварительных предложений
  PARTICIPANT_OFFERS_REGISTER = 'ParticipantOffersRegister',
  // Реестр комиссий
  COMMISSIONS_REGISTER = 'CommissionsRegister',
  // Информация об организации
  ORGANIZATION_INFORMATION = 'OrganizationInformation',
  // Пользователи
  USERS = 'Users',
  // Подразделения
  DIVISIONS = 'Divisions',
  // Информация о представителе
  REPRESENTATIVE_INFORMATION = 'RepresentativeInformation',
  // Система уведомлений
  NOTIFICATION_SYSTEM = 'NotificationSystem',
  // Настройка машиночитаемых доверенностей
  POWER_OF_ATTORNEY_SETTINGS = 'PowerOfAttorneySettings',
  // Реквизиты для перечисления
  TRANSFER_DETAILS = 'TransferDetails',
  // Реестр заявок по перечислению
  TRANSFER_REGISTRY = 'TransferRegistry',
  // История действий пользователей
  USER_ACTIONS_HISTORY = 'UserActionsHistory',
  // Реестр машиночитаемых доверенностей
  POA_REGISTRY_CATEGORY = 'PoaRegistryCategory',
  // Неизвестно
  UNKNOWN = 'Unknown',
}
